var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-contaner"},[_c('div',[_c('fade-loader',{attrs:{"loading":_vm.loading,"color":'grey',"size":'120px'}}),_c('p',{staticClass:"icon-text"},[_vm._v("Please wait")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }